import styled from 'styled-components/macro'

import { Accordion, Layout, Tag, Text } from '@loadsmart/loadsmart-ui'

import { type FullMode } from 'core/domain/Mode'
import { formatMode } from 'core/presenters/modePresenter'
import { formatDescription, formatZip } from 'core/presenters/stopPresenter'
import { StopsTimeline } from 'core/ui/components/stop/StopsTimeline'

import { screen } from 'legacy/styles/screen'

import { type EquipmentSize } from '../domain/EquipmentSize'
import { type EquipmentType } from '../domain/EquipmentType'
import { type Lane } from '../domain/Lane'
import { getEquipmentTypeAndSizeLabel } from '../presenters/equipmentSizePresenter'
import { getAwardedTypeInfo, getAwardedVolume } from '../presenters/rfpAwardedPresenter'

const ColumnWrapper = styled.div`
  flex-basis: 100%;

  ${screen.md} {
    flex-basis: 50%;
  }
`

const MoreInfoSectionWrapper = styled(Layout.Group)`
  flex-wrap: wrap;

  ${screen.md} {
    flex-wrap: unset;
  }
`

export type AwardedLaneItemAccordionProps = {
  rfpId: string
  position: number
  awardedLane: Lane
}

export function AwardedLaneItemAccordion({
  rfpId,
  position,
  awardedLane,
}: AwardedLaneItemAccordionProps) {
  let preferenceEquipmentType: EquipmentType | undefined
  let preferenceEquipmentSize: EquipmentSize | undefined
  let preferenceMode: FullMode | undefined

  const { notes, preferences } = awardedLane

  preferenceEquipmentType = preferences[0].equipmentType
  preferenceEquipmentSize = preferences[0].equipmentSize
  preferenceMode = preferences[0].mode

  const { label, tagVariant } = getAwardedTypeInfo(awardedLane)
  const stops = awardedLane.stops
  const awardedVolume = getAwardedVolume(awardedLane)

  return (
    <Accordion initialExpanded={false}>
      <Accordion.Toggle>
        <Layout.Group align="center" space="s">
          <Layout.Group align="center">
            {/* @ts-expect-error disregarding other variants besides "accent" or "default" */}
            <Tag variant={tagVariant}>{label}</Tag>
            <Text variant="heading-sm-bold">{formatMode(preferenceMode!)}</Text>
            <Text variant="heading-sm-bold">
              {getEquipmentTypeAndSizeLabel(preferenceEquipmentType, preferenceEquipmentSize, true)}
            </Text>
            {awardedVolume && <Text>{awardedVolume}</Text>}
          </Layout.Group>
        </Layout.Group>
      </Accordion.Toggle>
      <Accordion.Body>
        <MoreInfoSectionWrapper>
          <ColumnWrapper>
            <StopsTimeline
              stops={stops}
              titleFormatter={formatDescription}
              subTitleFormatter={formatZip}
              tags
            />
          </ColumnWrapper>
          <ColumnWrapper>
            <Layout.Stack space="l">
              <Layout.Group space="3xl">
                <Layout.Stack>
                  <Text variant="heading-sm-bold">Mode</Text>
                  <Text>{formatMode(preferenceMode)}</Text>
                </Layout.Stack>
                <Layout.Stack>
                  <Text variant="heading-sm-bold">Equipment</Text>
                  <Text>
                    {getEquipmentTypeAndSizeLabel(
                      preferenceEquipmentType,
                      preferenceEquipmentSize,
                      true
                    )}
                  </Text>
                </Layout.Stack>
              </Layout.Group>
              {notes && (
                <Layout.Stack>
                  <Text variant="heading-sm-bold">Notes</Text>
                  <Text>{notes}</Text>
                </Layout.Stack>
              )}
            </Layout.Stack>
          </ColumnWrapper>
        </MoreInfoSectionWrapper>
      </Accordion.Body>
    </Accordion>
  )
}
